import React from 'react'
import Regenerate from '../Regenerate/Regenerate'
import { useSpring, animated, easings } from "react-spring";

const Pulse = (props) => {
  const { showMaximumChat, data, updateMessage, loading ,sessionId,index ,setIsFeedbackPop ,messages ,checkThumsDownFeedback } = props
    // const htmlString = item?.replace(/\n/g, '<br>');
    // const [ Text] = item.value.split('\n\n');
    // const pointers = Text.split('\n')
    // .map(key => key.replace(/^\d+\.\s*/, '')) // Remove the number at the start of each instruction
    // .filter(key => key.trim().length > 0); 

    const fadeInProps = useSpring({
      from: { opacity: Math.random() },
      to: { opacity: 1 },
      config: { duration: 1000, easing: easings.easeInOut },
      // Adjust duration and easing as needed
  });
    return (
        <div>
           
           <div className="channel-list-reponse" style={{ color: '#220046' }} dangerouslySetInnerHTML={{ __html: data?.llm_response[0]?.llm_response }}></div>
           {/* <Regenerate msg={data} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} index={index} messages={messages} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} /> */}
        </div>
    )
}

export default Pulse
